import React, {Component} from "react";
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from "reactstrap";
import AuthService from '../../../components/AuthService';
import 'react-toastify/dist/ReactToastify.css';
import LoginNotificationSystem from './LoginNotificationSystem';
import posed from 'react-pose';
import { AnimatedDivSlide, AnimatedDivOpacity } from '../../../../src/animations/index';



class Login extends Component {


    constructor(props){
        super(props);
        this.state =
            {
                username: '',
                password: '',
                pageisDoneLoading:false,
                slideAnimationDone:false,
            };
        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.Auth = new AuthService();


    }

    componentWillMount(){
        if(this.Auth.loggedIn()) {
            this.props.history.replace('/');
        }
    }


    componentDidMount() {
        this.setState(
            {
                username: '',
                password: '',
                pageisDoneLoading:true,
        });
    }

    goToNewPage(path) {
        this.setState({slideAnimationDone:false},() => {
            setTimeout(() => {
                this.setState({pageisDoneLoading:false},() => {
                    setTimeout(() => {
                        this.props.history.replace(path);
                    },600)
                });
            }, 500);

        });
    }

    render() {
        return (
            <div className="app flex-row align-items-center" id="introBackground">
                <LoginNotificationSystem ref="notification"/>

                <AnimatedDivSlide
                    pose={this.state.pageisDoneLoading ? 'visible' : 'hidden'}
                    className="login-container d-flex justify-content-center flex-column"
                    onPoseComplete={() => this.setState({slideAnimationDone: true})}
                >
                    <div className="flex-column px-lg-5 p-5 d-flex align-items-center">
                        <AnimatedDivOpacity
                            pose={this.state.slideAnimationDone ? 'visibleOpacity' : 'hiddenOpacity'}
                        >
                        <CardBody className="card-body">

                            <form onSubmit={this.handleFormSubmit}>
                                <h1>Login to Continue</h1>
                                <p className="text-muted">Welcome back, sign into your account</p>

                                <InputGroup className="mb-3">
                                    <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="icon-user"></i>
                                                </span>
                                    </div>
                                    <Input type="text" placeholder="Username" name="username" onChange={this.handleChange}/>
                                </InputGroup>

                                <InputGroup className="mb-4">
                                    <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className="icon-lock"></i>
                                                </span>
                                    </div>
                                    <Input type="password" placeholder="Password" name="password" onChange={this.handleChange}/>
                                </InputGroup>
                                <Row>
                                    <Col xs="12" className="mb-4">
                                        <Button color="primary" className="px-4 btn btn-block" value="SUBMIT" type="submit">Login</Button>
                                    </Col>
                                </Row>
                            </form>
                            <Row>
                                <Col sm="12">
                                    <hr className="mb-4"/>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <Col xs="12" >
                                        Don't have an account yet? <button className="btn btn-link text-black-50" onClick={() => this.goToNewPage('/register/none/none')}>Register with Referal ID</button><br/>
                                        Forgot your username or password? <button className="btn btn-link text-black-50" onClick={() => this.goToNewPage('/passwordReset')}>Reset Password</button>
                                    </Col>
                                </Col>
                            </Row>
                        </CardBody>
                        </AnimatedDivOpacity>
                    </div>
                </AnimatedDivSlide>
            </div>
        );
    }



    handleFormSubmit(e){
        e.preventDefault();

        if (this.state.username === '') {
            this.refs.notification.notify('Username is required.','error');
        }
        else if(this.state.password === '') {
            this.refs.notification.notify('Password is required. If you have lost your login credentials please notify our support desk.','error');
        }
        else {
            this.Auth.login(this.state.username,this.state.password)
                .then(res =>{
                    this.props.history.replace('/');
                })
                .catch(err =>{
                    this.refs.notification.notify('Invalid credentials, please check your username and password.','error');
                })
        }

    }

    handleChange(e){

        this.setState(
            {
                [e.target.name]: e.target.value
            }
        )
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js